<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row mb-4">
            <div class="col-12">
                <h1 class="title-default">Relatórios de Finanças</h1>
                <p class="welcome-message">Aqui você encontra todos os relatórios do seu módulo de finanças.</p>
            </div>
        </div>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" formControlName="pesquisa"
                            placeholder="Pesquisar relatório..." (input)="filtrar()">
                        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if (nenhumResultado) {
            <div class="empty-state">
                <mat-icon class="empty-icon">description</mat-icon>
                <p>Nenhum relatório financeiro disponível no momento.</p>
            </div>
        } @else {
            @for (categoria of categoriasFiltradas; track categoria.titulo) {
                <div class="categoria-section">
                    <span class="categoria-titulo">{{ categoria.titulo | uppercase }}</span>

                    <div class="relatorios-list">
                        @for (relatorio of categoria.relatorios; track relatorio.rota) {
                            <span class="relatorio-tooltip-wrapper">
                                <button class="relatorio-item" type="button"
                                    (click)="navegar(relatorio)">
                                    <div class="relatorio-left">
                                        <mat-icon class="relatorio-icon">{{ relatorio.icon }}</mat-icon>
                                        <span class="relatorio-nome">{{ relatorio.nome }}</span>
                                    </div>
                                    <mat-icon class="relatorio-chevron">chevron_right</mat-icon>
                                </button>
                            </span>
                        }
                    </div>
                </div>
            }
        }
    </div>
</div>
